import { useEffect } from 'react';
import { prop, propOr } from '../utils/fp';
import { useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import { getIsRtl, getLocale, getPathname } from '../selectors/router';
import { getDataflowName } from '../selectors/sdmx';
import { formatMessage } from '../i18n';
import messages from './messages';

// Document metadata is written straight to the DOM: the app mounts this once
// and it owns the title and the html lang/dir for the whole session.
const View = () => {
  const intl = useIntl();
  const isRtl = useSelector(getIsRtl);
  const lang = useSelector(getLocale);
  const dataflowName = useSelector(getDataflowName);
  const pathname = useSelector(getPathname);

  const title = formatMessage(intl)(propOr(prop('/', messages), pathname, messages), {
    dataflowName,
  });
  const dir = isRtl ? 'rtl' : 'ltr';

  useEffect(() => {
    document.title = title;
  }, [title]);

  useEffect(() => {
    document.documentElement.lang = lang;
    document.documentElement.dir = dir;
  }, [lang, dir]);

  return null;
};

export default View;
